export default __webpack_public_path__ + "static/media/ayomide_cartoon.708ab314.png";